import type { ZoneId } from '@fukemon/shared';
import { useGameStore } from '../state/gameStore';
import { Icon } from './Icon';

const ZONES: Array<{
  id: ZoneId;
  panel: 'market' | 'raid' | 'vault' | 'arcade';
  label: string;
  sub: string;
  icon: 'chart' | 'trophy' | 'shield' | 'archive';
}> = [
  { id: 'exchange', panel: 'market', label: 'EXCHANGE', sub: 'Make today’s call', icon: 'chart' },
  { id: 'raid', panel: 'raid', label: 'RAID PIT', sub: 'Weekly boss', icon: 'trophy' },
  { id: 'vault', panel: 'vault', label: 'FUKÉVAULT', sub: 'Cards & drip', icon: 'shield' },
  { id: 'arcade', panel: 'arcade', label: 'ARCADE', sub: 'Fossil quests', icon: 'archive' }
];

export function ZoneNav() {
  const zone = useGameStore((state) => state.zone);
  const setZone = useGameStore((state) => state.setZone);
  const setPanel = useGameStore((state) => state.setPanel);

  return (
    <nav className="zone-nav" aria-label="District zones">
      {ZONES.map((item) => (
        <button
          key={item.id}
          aria-label={`${item.label}: ${item.sub}`}
          className={zone === item.id ? 'zone-button zone-button--active' : 'zone-button'}
          onClick={() => {
            setZone(item.id);
            setPanel(item.panel);
          }}
        >
          <Icon name={item.icon} size={19} />
          <span>
            <strong>{item.label}</strong>
            <small>{item.sub}</small>
          </span>
        </button>
      ))}
    </nav>
  );
}
